import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { Spin } from "antd";
import "./index.less";
import { useLocation } from "react-router-dom";
import useWeatherData from "./components/SelfHooks/useWeatherData";
import dayjs from "dayjs";
import { RootState } from "@/redux/reducer/store";
import { useSelector} from "react-redux";
import AGForcastButton from "@/components/ForecastProviderButton";
import useWeatherTranslate from "./components/SelfHooks/useWeatherTranslate";
import useSeries from "./components/SelfHooks/useSeries";
import { checkServiceTokenIsValid } from "@/util/http";
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

import useResizeObserver from "@/util/selfhook/useResizeObserver";

interface ISearchObj{
    theme?: string;
    country?: string;
    language?: string;
    lat?: number;
    long?: number;
    startdate?: string;
    enddate?: string;
    unit?: string;
    gddmax?: number;
    gddmin?: number;
    securitykey?:string;
}
const CountryDateFormat = {
    "AE": "DD/MM/YYYY",
    "AU": "DD/MM/YYYY",
    "BY": "DD.MM.YY",
    "CH": "DD.mm.YY",
    "DE": "DD.MM.YYYY",
    "NZ": "DD-MM-YYYY",
    "US": "MM/DD/YYYY",
    "ES": "DD/MM/YYYY",
    "FR": "DD/MM/YYYY",
    "GB": "DD/MM/YYYY",
    "IL": "DD/MM/YYYY",
    "JP": "YYYY/MM/DD",
    "KR": "YYYY-MM-DD",
    "PL": "DD.MM.YYYY",
    "PT": "DD-MM-YYYY",
    "SE": "YYYY-MM-DD",
    "SI": "DD.MM.YYYY",
    "TR": "DD.MM.YYYY",
    "ZA": "DD/MM/YYYY"
};

const agWeather = ()=>{

    const urlLocation = useLocation();

    const {
        showLodding,
        isExecuteDone
    } = useSelector((state: RootState) => state.diseaseReducer);
    const {
        homeIndexLoading,
    } = useSelector((state: RootState) => state.commonReducer);

    // add google analysis
    useEffect(() => {
        console.log("just invoke once");
        const head = document.getElementsByTagName("head")[0];
        const googleAnalyticsCode = "G-F8EZJMCB9J";
        const googleAnalyticsFirstScript = document.createElement("script");
        googleAnalyticsFirstScript.async = true;
        googleAnalyticsFirstScript.src =
          "https://www.googletagmanager.com/gtag/js?id=" + googleAnalyticsCode;

        const googleAnalyticsSecondScript = document.createElement("script");
        googleAnalyticsSecondScript.innerHTML =
          "    window.dataLayer = window.dataLayer || [];\n" +
          "    function gtag(){dataLayer.push(arguments);}\n" +
          "    gtag('js', new Date());\n" +
          "\n" +
          "    gtag('config', '" +
          googleAnalyticsCode +
          "',{\n" +
          "cookie_flags:'max-age=7200;secure;samesite-none'" +
          "});";

        head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
        head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
    }, []);

    // static value
    const pubname = "geotroll1";
    const servicepage = "HistoryData_ECMWF";
    const unit = "imperial";

    // set the search obj
    const [searchObj,setSearObj] = useState<ISearchObj>({
        theme: "light",
        country: "GB",
        language: "en",
        long: 0.1278,
        lat: 51.5074,
        startdate: dayjs().subtract(1,"day").subtract(1,"month").format("DD/MM/YYYY"),
        enddate: dayjs().subtract(2,"day").format("DD/MM/YYYY"),
        unit: "imperial",
        gddmax: 140,
        gddmin: 32,
        securitykey: null
    });

    useEffect(()=>{
        document.body.style.backgroundColor = searchObj?.theme === "light" ? "white" : "black";
    },[searchObj?.theme]);

    const initSearchObj = ()=>{
        const searchStr = location?.search.replace("?","");
        const searchArr = searchStr?.split("&");
        const tmpSearchObj = {...searchObj};
        let tmpStartDate = "";
        let tmpEndDate = "";
        let tmpCountry = "";
        let haveSecurityFlag = false;
        searchArr?.map((item)=>{
            const searchKeyValue = item?.split("=");
            if( searchKeyValue[0].toLowerCase() === "lat" ||
                searchKeyValue[0].toLowerCase() === "long" ||
                searchKeyValue[0].toLowerCase() === "gddmax" ||
                searchKeyValue[0].toLowerCase() === "gddmin"
            ){
                tmpSearchObj[searchKeyValue[0].toLowerCase()] = Number(searchKeyValue[1]);
            }
            else if(searchKeyValue[0].toLowerCase() === "startdate"){
                // tmpSearchObj[searchKeyValue[0].toLowerCase()] = dayjs(searchKeyValue[1],tmpFormat).format("DD/MM/YYYY");
                tmpSearchObj[searchKeyValue[0].toLowerCase()] = searchKeyValue[1];
                tmpStartDate = searchKeyValue[1] ;
            }
            else if(searchKeyValue[0].toLowerCase() === "enddate"){
                // tmpSearchObj[searchKeyValue[0].toLowerCase()] = dayjs(searchKeyValue[1],tmpFormat).format("DD/MM/YYYY");
                tmpSearchObj[searchKeyValue[0].toLowerCase()] = searchKeyValue[1];
                tmpEndDate = searchKeyValue[1];
            }
            else if(searchKeyValue[0].toLowerCase() === "country"){
                // tmpSearchObj[searchKeyValue[0].toLowerCase()] = dayjs(searchKeyValue[1],tmpFormat).format("DD/MM/YYYY");
                tmpSearchObj[searchKeyValue[0].toLowerCase()] = searchKeyValue[1];
                tmpCountry = searchKeyValue[1];
            }
            else if(searchKeyValue[0].toLowerCase() === "securitykey"){
                if(searchKeyValue[1]){
                    tmpSearchObj[searchKeyValue[0].toLowerCase()] = searchKeyValue[1];
                    haveSecurityFlag = true;
                }
            }
            else{
                tmpSearchObj[searchKeyValue[0].toLowerCase()] = searchKeyValue[1];
            }
        });
        /**
         * below is ensure enddate must small then startdate
         * TODO: here missed some logic, we need conside not provide startData or endDate, or all not provide
         */
        const tmpFormat = CountryDateFormat[tmpCountry] || "DD/MM/YYYY";
        if(!tmpStartDate && !tmpEndDate){
            // option 1: not provide startdate and enddate
            tmpSearchObj.startdate = searchObj.startdate;
            tmpSearchObj.enddate = searchObj.enddate;
        }
        else if(!tmpStartDate && tmpEndDate){
            // option 2: not provide start date, but provide end date
        }
        else if(tmpStartDate && !tmpEndDate){
            // option 3: provide start date, but not provide end date
        }
        else{
            // option 4: already provide start date and end date
            tmpSearchObj.startdate = dayjs(tmpStartDate,[tmpFormat,"YYYY-MM-DD"]).format("DD/MM/YYYY");
            const tmpDate = dayjs(tmpEndDate,[tmpFormat,"YYYY-MM-DD"]);
            const tmpYesterday = dayjs().subtract(1,"day");
            const tmpFinalEndDate = tmpDate.isAfter(tmpYesterday) ? tmpYesterday : tmpDate;
            // tmpSearchObj.enddate = dayjs(tmpEndDate,[tmpFormat,"YYYY-MM-DD"]).format("DD/MM/YYYY");
            tmpSearchObj.enddate = tmpFinalEndDate.format("DD/MM/YYYY");
        }
        if(!haveSecurityFlag){
            tmpSearchObj.securitykey = "no-value";
        }
        setSearObj(tmpSearchObj);
    };

    // download the image
    const saveMapToDataUrl = ()=>{
        const element = document.getElementById("chartContentDiv");
        const element1 = document.querySelector(".rightLatLng") as HTMLElement;
        element1.style.display = "block";
        if(element){
            html2canvas(element,{
                useCORS: true
            }).then((canvas)=>{
                const dataUrl = canvas.toDataURL("image/png");
                console.log("test images",dataUrl);

                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = searchObj.country + ".png";
                link.click();
                element1.style.display = "none";
            });
        }
    };

    // chart type
    const [chartOptions,setChartOptions] = useState([
        {
            chart_name: "Air Temperature",
            chart_id: "Air Temperature",
            chart_echart_y_name: "Air Temperature",
            isChecked: true,
            colorAndId: [
                {
                    risk_name: "Air Temperature Max",
                    risk_id: "tempair_c_daytimemax_AltAdj",
                    risk_color: "#E99921"
                },
                {
                    risk_name: "Air Temperature Min",
                    risk_id: "tempair_c_nighttimemin_AltAdj",
                    risk_color: "#31B4F2"
                }
            ]
        },
        {
            chart_name: "Accumulated GDD",
            chart_id: "Accumulated GDD",
            chart_echart_y_name: "Accumulated GDD",
            isChecked: false,
            colorAndId: [
                {
                    risk_name: "Daily GDD",
                    risk_id: "gdd_c_dailysum",
                    risk_color: "#14803C"
                },
                {
                    risk_name: "Daily Accumulative",
                    risk_id: "gdd_c_accumulated",
                    risk_color: "#005693"
                }
            ]
        }
    ]);

    const publicChangeChartOptions = (value:boolean,index:number) =>{
        const tmpChartOptions = [...chartOptions];
        tmpChartOptions[index].isChecked = value;

        setChartOptions(tmpChartOptions);
    };



    // color and id array, echart data used in Echarts components
    const [selectedType,setSelectedType] = useState<string[]>([]);
    const [colorArray,setColorArray] = useState<string[]>([]);
    const [idArray,setIdArray] = useState<string[]>([]);
    const [echartSeriesName,setEchartSeriesName] = useState<string[]>([]);
    const echartContainerRef = useRef(null);

    // get echart data and translate
    const {echartData} = useWeatherData({
        country: searchObj.country,
        language: searchObj.language,
        latitude: searchObj.lat,
        longitude: searchObj.long,
        unit: searchObj.unit,
        startdate: searchObj.startdate,
        enddate: searchObj.enddate,
        gddmax: searchObj.gddmax,
        gddmin: searchObj.gddmin,
        isExecute: isExecuteDone
    });
    const {weacherTranslate} = useWeatherTranslate({
        countryCode: searchObj.country,
        language: searchObj.language
    });
    const {seriesOptions} = useSeries({
        countryCode: searchObj.country,
        culture: searchObj.language + "-" + searchObj.country,
        unit: searchObj.unit,
        servicepage: servicepage,
        pubname: pubname
    });

    const TemperatureUnitObj = {
        "imperial": "°F",
        "metric": "℃"
    };

    const getSplitName = (text: string)=>{
        let tmpName = "";
        const tmpText = text?.split(" ");
        if(tmpText?.length >= 3){
            tmpName = tmpText[0] + " " + tmpText[1] + " " + tmpText[2];
        }
        return tmpName;
    };


    // =============== useEffuct =================
    useEffect(() => {
        // init the searchobj, and the value data is form the url
        initSearchObj();
    }, [urlLocation]);
    // change color and id array, which used in the Echart components
    useEffect(()=>{
        const tmpColorArray = [];
        const tmpIdArray = [];
        const tmpSelectedType = [];
        const tmpEchartSeriesName = [];
        const tmpSelectedObj = [];
        chartOptions?.forEach((item)=>{
            if(item?.isChecked){
                item?.colorAndId?.forEach((innerItem)=>{
                    tmpColorArray.push(innerItem.risk_color);
                    tmpIdArray.push(innerItem.risk_id);
                    tmpEchartSeriesName.push(innerItem.risk_name);
                });
                // change selected type
                if(item?.chart_id === "Air Temperature"){
                    tmpSelectedType.push(item?.chart_name + " " + TemperatureUnitObj[searchObj?.unit]);
                }
                else{
                    // tmpSelectedType.push(item?.chart_name);
                    tmpSelectedType.push(item?.chart_echart_y_name);
                }
            }
        });
        setColorArray(tmpColorArray);
        setIdArray(tmpIdArray);
        setEchartSeriesName(tmpEchartSeriesName);
        setSelectedType(tmpSelectedType);
    },[chartOptions]);
    useEffect(()=>{
        if(weacherTranslate || seriesOptions?.length > 0){
            const tmpChartOptions = [...chartOptions];
            tmpChartOptions[0].chart_name = weacherTranslate.txt_AirTemperature;
            tmpChartOptions[1].chart_name = weacherTranslate.txt_AccumulatedGDD;
            tmpChartOptions[1].chart_echart_y_name = weacherTranslate.txt_GDD;

            // setColorAndId
            // for Air Temperature Max and Air Temperature Min
            // tmpChartOptions[0].colorAndId[0].risk_name = seriesOptions[1]?.text;
            // tmpChartOptions[0].colorAndId[1].risk_name = seriesOptions[2]?.text;
            tmpChartOptions[0].colorAndId[0].risk_name = getSplitName(seriesOptions[1]?.text);
            tmpChartOptions[0].colorAndId[1].risk_name = getSplitName(seriesOptions[2]?.text);
            tmpChartOptions[1].colorAndId[0].risk_name = seriesOptions[3]?.text;
            tmpChartOptions[1].colorAndId[1].risk_name = seriesOptions[4]?.text;

            setChartOptions(tmpChartOptions);
        }
    },[weacherTranslate,seriesOptions]);

    // const [screenSize,setScreenSize] = useState("index");

    const [showPageByToken,setShowPageByToken] = useState(true);
    const isFirstRender = useRef(true);
    const checkServiceTokenIsValidFunc = async()=>{
        try{
            const res = await checkServiceTokenIsValid(searchObj.securitykey);
            setShowPageByToken(res.data);
            if(!res.data){
                const element1 = document.querySelector(".dark-theme") as HTMLElement;
                if(element1){
                    element1.style.backgroundColor = "white";
                }
            }
        }
        catch(error){
            console.log("error",error);
        }
    };
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; // first render
            return; // when first render, do nothing
        }
        // if(searchObj?.securitykey){
        //     if(searchObj.securitykey === "no-value"){
        //         setShowPageByToken(false);
        //     }
        //     else{
        //         checkServiceTokenIsValidFunc();
        //     }
        // }
    },[searchObj.securitykey]);




    const [finalCheckedSeries,setFinalCheckedSeries] = useState<string>("node1_cb_TempAir_C_DaytimeMax;node1_cb_TempAir_C_NighttimeMin;node5_cb_GDD_C_DailySum;node5_cb_GDD_C_Accumulated");
    // const [finalSeriesName,setFinalSeriesName] = useState<string>("Air Temperature Max;Air Temperature Min;Daily GDD;Daily Accumulative;");
    const [finalSeriesName,setFinalSeriesName] = useState<string>("");
    const [finalButtonName,setFinalButtonName] = useState<string>("Air Temperature;Accumulated GDD;");
    const [finalYTitle,setFinalYTitle] = useState<string>("Air temperature (°F);Growing Degree Days(GDD);");
    const [finalContainerTitle,setFinalContainerTitle] = useState<string>("Select the options below to add or remove graph parameters");
    const [finalDownloadName,setFinalDownloadName] = useState<string>("Download as Image");
    useEffect(()=>{
        if(weacherTranslate && seriesOptions?.length > 0){
            // for searies Name  test
            const tmpAirMax = getSplitName(seriesOptions[1]?.text) || "Air Temperature Max";
            const tmpAirMin = getSplitName(seriesOptions[2]?.text) || "Air Temperature Min";
            const tmpUnit = searchObj?.unit === "imperial" ? "°F" : "℃";
            const tmpMax = tmpAirMax?.split("(")?.[0] + "(" + tmpUnit + ")";
            const tmpMin = tmpAirMin?.split("(")?.[0] + "(" + tmpUnit + ")";
            const tmpGDDDaily = seriesOptions[3]?.text || "Daily GDD";
            const tmpGDDAccumulative = seriesOptions[4]?.text || "Daily Accumulative";
            const tmpFinalSeriesName = (tmpAirMax + ";" +
                                        tmpAirMin + ";" +
                                        tmpGDDDaily + ";" +
                                        tmpGDDAccumulative + ";");

            setFinalSeriesName(tmpFinalSeriesName);


            // for Button Name
            const tmpFinalButtonName = weacherTranslate.txt_AirTemperature + ";" +
                                       weacherTranslate.txt_AccumulatedGDD + ";";
            setFinalButtonName(tmpFinalButtonName);

            // for Y Title
            const tmpFinalTTitle = weacherTranslate.txt_AirTemperature + " (" + (TemperatureUnitObj?.[searchObj?.unit] || "°F")+ ");" +
                                   weacherTranslate.txt_GDD + ";";
            setFinalYTitle(tmpFinalTTitle);

            // for Container Title
            const tmpFinalContainerTitle = weacherTranslate.txt_SelOptionsAddRemoveGraph;
            setFinalContainerTitle(tmpFinalContainerTitle);

            // download as image
            const tmpFinalDownloadName = weacherTranslate.txt_DownloadAsImage || "Download as Image";
            setFinalDownloadName(tmpFinalDownloadName);

        }
    },[weacherTranslate,searchObj?.unit,seriesOptions]);

    console.log("lanxue histweather chartOptions",chartOptions);
    console.log("lanxue histweather finalButtonName",finalButtonName);
    console.log("lanxue histweather finalSeriesName",finalSeriesName);
    console.log("lanxue histweather finalYTitle",finalYTitle);
    console.log("lanxue histweather finalContainerTitle",finalContainerTitle);

    //for chart width
    const getWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const [screenWidth, setScreenWidth] = useState(getWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [screenWidth]);
    console.log("6666 screenWidth",screenWidth);
    const [ref, size] = useResizeObserver<HTMLDivElement>({
        // 可选参数
        debounceDelay: 100,
        roundValues: true,
        useAnimationFrame: true
    });

    console.log("6666 size",size);

    return(
        <>
            {
                showPageByToken?
                    <div className="hist-weather-container"
                        ref={ref}
                    >
                        <div className={`bg-${searchObj.theme}`}>
                            <Spin spinning={showLodding || homeIndexLoading}>
                                <div className={"hist-weather"}>
                                    <weather-chart-widget
                                        key={size.width}
                                        // width={(0.79*(size.width)).toString()}
                                        width={((size?.width > 1000 ? 0.79 : 1) * (size.width)).toString()}
                                        height="420"
                                        showtitle="true"
                                        showdownload="true"
                                        language={searchObj?.language}
                                        country-code={searchObj?.country}
                                        unit={searchObj?.unit}
                                        lat={(searchObj?.lat)?.toString()}
                                        lon={(searchObj?.long)?.toString()}
                                        place-name={null}
                                        start-date={(searchObj?.startdate)?.toString()}
                                        end-date={(searchObj?.enddate)?.toString()}
                                        checked-series={finalCheckedSeries}
                                        source = "meteoblue-greencast"
                                        max-distance-diff={searchObj?.gddmin}
                                        max-altitude-diff={searchObj?.gddmax}
                                        series-name-array={finalSeriesName}
                                        button-name-array={finalButtonName}
                                        y-title={finalYTitle}
                                        container-title={finalContainerTitle}

                                        download-name={finalDownloadName}

                                        chart-name="hist-weather"
                                        precipitation-dataset = {searchObj?.country=="AU"?"CHIRPS2":"ERA5T"}
                                        dataset = {searchObj?.country=="AU"?"ICON":"ERA5T"}
                                    ></weather-chart-widget>
                                    {/* forcast button */}
                                    <AGForcastButton
                                        buttonName={weacherTranslate?.txt_SeeForecastProviderData}
                                        closeName={weacherTranslate?.close}
                                        forecastProvider={weacherTranslate?.txt_ForecastProviderData}
                                        meteoblueForecast={weacherTranslate?.txt_MeteoblueForecast}
                                        modalContentOne={weacherTranslate?.txt_ForecastProviderContentP1}
                                        modalContentTwo={weacherTranslate?.txt_ForecastProviderContentP2}
                                        modalContentThree={weacherTranslate?.txt_ForecastProviderContentP3}
                                    />
                                </div>
                            </Spin>
                        </div>
                    </div>
                    :
                    <div className="error_page">
                        <div className="error_content">
                            <span>There is an issue with accessing the page. </span>
                            <span>Please provide the correct token.</span>
                        </div>
                    </div>
            }
        </>

    );
};

export default agWeather;


